module.exports = __webpack_public_path__ + "static/key-tropicoelprez-8d52000e847c5fad1c6e92d3f3416a9d.webp";